export default (eventName, props = {}) => {
  if (typeof window === "undefined") return;
  const server = props.server || (window.s && window.s.server);

  const commonProps = {
    pageName: `${server}|our apps`,
    prop1: "discover | our apps",
    prop8: "discover | our apps",
    channel: "our apps",
    prop31: props.loginStatus,
    eVar10: props.customerId,
  };

  const config = {
    "page-load": {
      linkVars: {
        prop8: commonProps.pageName,
        eVar15: commonProps.pageName,
        eVar60: commonProps.pageName,
        eVar61: commonProps.pageName,
        ...commonProps,
      },
    },
  };

  return config[eventName];
};
